import type { FaireProductEntity } from "../../entity_types/product";

export const p_ns4qq4zqqm: FaireProductEntity = {
  token: "p_ns4qq4zqqm",
  type: "product",
  name: "ANIMAL PRINT BUTTON DOWN CROP TOP",
  brandToken: "b_22tswwgnqb",
  brandName: "Emory Park",
  imageUrl:
    "https://cdn.faire.com/fastly/3a8186f780f8f26307261a588a31e08eb3a5605e5509cd1b755e1236f4a3ce8f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e73115073bee36861859f2bf9f13eb28849e2d6a2bc145121fbcedb4e284e7f6.jpeg",
    "https://cdn.faire.com/fastly/2206911d1bc406efa3bab18962118a108b02b6609c4d8beb19ca5e5df395da6b.jpeg",
    "https://cdn.faire.com/fastly/5cb1050c82f7471ffde06c9d5d1ddd6ad63ed53d71a52d0b71af3a9cabc51be3.jpeg",
    "https://cdn.faire.com/fastly/d89e56dced61bee08a0865c5992d28aac3560bf3d8bccceb268b78ee25f4ef6b.jpeg",
    "https://cdn.faire.com/fastly/b18147bb314895edc69faaaa04b1bc670c8429ccff1bf80cdd0d1195f7c8a91b.jpeg",
    "https://cdn.faire.com/fastly/d8a974650f1a2360f2dfa0b2bdbb717f0d43ce2294447a4393eda621e4087ecf.jpeg",
  ],
  priceDollars: 149.65,
  description: "SIZE & FIT :\n\nMODEL WEARS SIZE SMALL\nMODEL'S HEIGHT 5'9",
  tags: [],
  msrpDollars: 332.56,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:07:29.336Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
